<template>
    <Vue100vh class="login">
        <CircleWrap v-if="$route.name !== 'koeb-entre-success'" @click.native="$router.push('/')">
            <BackIconThin/>
        </CircleWrap>
        <div class="content-wrap">
            <div class="logo">
                <Logo/>
            </div>
            <router-view></router-view>
        </div>
    </Vue100vh>
</template>

<script>
	import Vue100vh from 'vue-div-100vh'
	import CircleWrap from "@/components/CircleWrap"
	import BackIconThin from "@/assets/icons/back-thin.svg"
	import Logo from "@/assets/login/login-logo.svg"
    import gsap from 'gsap'
	import {mapState} from "vuex";
	export default {
		components: {
			Vue100vh,
			CircleWrap,
			BackIconThin,
			Logo,
		},
		watch:{
			$route (to, from){
				let that = this
				setTimeout(function(){
					that.animateIn()
				}, 50)
			},
			hasPerformedInitialLoad(to){
				if(to === true && this.isAuthorized === true){
					if(this.$route.name !== 'koeb-entre-success')
					{
						this.$router.push({name: 'univers'});
					}
				}
			}
		},
		computed:{
			...mapState('vorbasse', {
				hasPerformedInitialLoad: 'hasPerformedInitialLoad',
				isAuthorized: 'isAuthorized',
			}),
		},
        mounted(){
			if(this.hasPerformedInitialLoad === true && this.isAuthorized === true)
			{
				if(this.$route.name !== 'koeb-entre-success')
				{
					this.$router.push({name: 'univers'});
				}
			}
            this.animateIn()
        },
        methods: {
			animateIn(){
				let tl = gsap.timeline();
				tl.to(".login .logo", {y: 0, x: 0, opacity: 1, duration: 0.3});
				tl.to(".login .box", {y: 0, x: 0, opacity: 1, duration: 0.3});
				tl.to(".login .brian", {y: 0, x: '-68%', opacity: 1, duration: 0.3});
				tl.to(".login .circle", {opacity: 1, x: 0, duration: 0.3, onComplete:function() {
                }});
            }
        }
	}
</script>

<style lang="scss">
    .login {
        background: $sky;
        position: fixed;
        width: 100vw;
        top: 0; left: 0;
        overflow-x: hidden;
        overflow-y: auto;
        .circle{
            background: $white;
            position: fixed;
            top: 15px;
            left: 15px;
            z-index: 3;
            svg{
                transform: translate(-70%, -50%);
            }
        }
        .content-wrap{
            padding: 30px 15px 150px;
            max-width: 375px;
            margin: 0px auto;
            .logo{
                position: fixed;
                top: 30px;
                left: 50%;
                transform: translateX(-50%);
                svg{
                    display: block;
                    width: 200px;
                    height: auto;
                }
            }
            .box-wrap{
                position: relative;
                padding-top: 270px;
                margin-top: 30px;
                .brian{
                    position: absolute;
                    top: 0px;
                    left: 50%;
                    transform: translateX(-68%)
                }
                .box{
                    display: block;
                    background: $white;
                    padding: 40px 35px;
                    border-radius: 24px;
                    position: relative;
                    .error-message{
                        background: #ffa4a4;
                        padding: 10px 15px;
                        border-radius: 20px;
                        font-size: 14px;
                        color: #753131;
                        border: 2px solid #c36b6b;
                    }
                    p{
                        font-size: 14px;
                        font-weight: bold;
                        color: $dark;
                        text-align: center;
                        margin-bottom: 30px;
                    }
                    ul{
                        margin: 0px 0px 30px;
                        padding: 0px;
                        li{
                            width: 33.33%;
                            float: left;
                            list-style: none;
                            .date-wrap{
                                display: block;
                                width: 57px;
                                background: $white;
                                border: 1px solid #979797;
                                color: $dark;
                                text-align: center;
                                border-radius: 6px;
                                font-size: 16px;
                                padding: 9px 0px 7px;
                                margin: 0px auto;
                                cursor: pointer;
	                            opacity: 0.5;
	                            &.disabled{
		                            background: rgba(0,0,0,0.2);
		                            opacity: 0.3;
		                            cursor: auto;
	                            }
                                &.selected{
                                    background: $othergreen;
                                    color: $white;
	                                opacity: 1;
                                }
                                .date{
                                    display: block;
                                    font-size: 24px;
                                    line-height: 18px;
                                }
                                .month{}
                            }
                        }
                        &:after{
                            display: block;
                            content: "";
                            clear: both;
                        }
                    }
                }
                input{
                    border: 2px solid $green;
                    color: $green;
                    text-align: center;
                    font-size: 20px;
                    font-weight: bold;
                    text-transform: uppercase;
                    margin-bottom: 15px;
                    padding: 13px 30px;
                    &::placeholder{
                        color: #979797;
                        font-size: 16px;
                        text-transform: none;
                        font-weight: normal;
                    }
                }
                button{
                    background: $green;
                    color: $white;
                    background: $othergreen;
                    text-transform: none;
                    padding: 12px;
                    margin-bottom: 50px;
                    &.big{
                        padding: 16px 12px;
                    }
                }
            }
        }
    }

    // Animationer
    .login{
        .circle{
            opacity: 0;
            transform: translateX(-50px);
        }
        .content-wrap{
            .sunshine{
                opacity: 0;
            }
            .logo{
                transform: translateX(-50%) translateY(-50px);
                opacity: 0;
            }
            .box-wrap{
                .brian{
                    transform: translateX(-68%) translateY(150px);
                    opacity: 0;
                }
                .box{
                    transform: translateY(75px);
                    opacity: 0;
                }
            }
        }
    }

</style>
